import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author OmerKosar
 */
const SubscriptionListing = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 50 },
			{ Header: 'clientName', accessor: 'clientName', filterType: FilterType.string },
			{ Header: 'clientEmail', accessor: 'clientEmail', filterType: FilterType.string, showOnMobile: true },
			{
				Header: 'clientPhone',
				accessor: 'clientPhone',
				width: 90,
				filterType: FilterType.string,
				renderCell: ListComponents.PHONE
			},
			{ Header: 'packageName', accessor: 'packageName', filterType: FilterType.string },
			{ Header: 'oldPackage', accessor: 'oldPackage', filterType: FilterType.string },
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string,
				width: 90
			},
			{
				Header: 'promoCodeUsed',
				accessor: 'promoCodeUsed',
				filterType: FilterType.enum,
				enumName: ENUMS.YES_NO
			},
			{ Header: 'referenceId', accessor: 'referenceId', filterType: FilterType.string },
			{ Header: 'amount', accessor: 'amount', filterType: FilterType.number, width: 50 },
			{ Header: 'paymentType', accessor: 'paymentType', filterType: FilterType.string },
			{
				Header: 'startDate',
				accessor: 'startDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'rechargeDate',
				accessor: 'rechargeDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{ Header: 'clientCardId', accessor: 'clientCardId', filterType: FilterType.string },
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'currency',
				accessor: 'currency',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CURRENCY
			},
			{
				Header: 'paidTransactions',
				accessor: 'paidTransactions',
				filterType: FilterType.number
			},
			{
				Header: 'previousPaidAmount',
				accessor: 'previousPaidAmount',
				filterType: FilterType.float
			}
		],
		[]
	);
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	return (
		<DynamicList
			id={DYNAMICLISTS.SUBSCRIPTION_LIST}
			columns={columns}
			defaultSort={defaultSort}
			fetchUrl={ADMIN.CONFIGURATION.GET_SUBSCRIPTION_LISTINGS}
			actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
			exportName="subscriptionListings"
		/>
	);
};

export default SubscriptionListing;
